/**
 * Closed [lon, lat] ring approximating a circle on the map (local equirectangular; fine at exercise scale).
 * @param {number} centerLon
 * @param {number} centerLat
 * @param {number} radiusMeters
 * @param {number} [segments=72]
 * @returns {Array<[number, number]>}
 */
export function geodesicCirclePathLonLat(centerLon, centerLat, radiusMeters, segments = 72) {
  const path = [];
  const mPerDegLat = 111320;
  const cosLat = Math.cos((centerLat * Math.PI) / 180);
  const mPerDegLon = 111320 * Math.max(0.02, Math.abs(cosLat));
  const n = Math.max(12, Math.floor(segments));
  for (let i = 0; i <= n; i++) {
    const theta = (i / n) * 2 * Math.PI;
    const eastM = radiusMeters * Math.cos(theta);
    const northM = radiusMeters * Math.sin(theta);
    path.push([centerLon + eastM / mPerDegLon, centerLat + northM / mPerDegLat]);
  }
  return path;
}
